import { Component, Inject } from '@angular/core';
import { PageTemplate, DeviceConfiguration } from '../models/page-layout.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'page-layout-dialog',
  template: `<div class="ap">
    <div mat-dialog-title>
Select Layout
        <button mat-dialog-close type="button" class="close" aria-label="Close" tabindex="-1" (click)="onCancel()"><span aria-hidden="true">&times;</span></button>
    </div>
    <div mat-dialog-content class="mat-dialog-content-padded">
        <div class="row around-xs">
            <div class="col-xs-12">
                <page-layout
                    class='pl'
                    (onSelected)="selectPageTemplate($event)">
                </page-layout>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <div class="action-buttons">
            <button mat-stroked-button class="small-button secondary-action" (click)="onCancel()">Cancel</button>
            <button mat-raised-button class="small-button" color="primary"
                                    [disabled]="isDisabled"
                                    (click)="onConfirm()" cdkFocusInitial>Select
            </button>
        </div>
    </div>
</div>`
})
export class PageLayoutDialog {

    deviceConfiguration: DeviceConfiguration;
    isDisabled: Boolean = true;

  constructor(public dialogRef: MatDialogRef<PageLayoutDialog>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }
  onCancel(): void {
    this.dialogRef.close({ confirm: false });
  }
  onConfirm(): void {
    this.dialogRef.close({ confirm: true, deviceConfiguration: this.deviceConfiguration });
  }
  selectPageTemplate(pageTemplate: PageTemplate) {
    this.deviceConfiguration = pageTemplate.deviceConfigurations;
    this.enableButton();
  }
  enableButton() {
    if (this.deviceConfiguration) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }
}
